import { render, staticRenderFns } from "./SidebarToggle.vue?vue&type=template&id=13b0e2c4&"
import script from "./SidebarToggle.vue?vue&type=script&lang=js&"
export * from "./SidebarToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports